import React, { PureComponent } from "react";
import ResponsiveEmbed from "react-responsive-embed";

class Video extends PureComponent {
  render() {
    const { video } = this.props;
    const { name, description, videoId } = video;

    const url = "https://www.youtube.com/embed/" + videoId;

    return (
      <div>
        <h2>{name}</h2>
        <h3>{description}</h3>

        <div className="youtube-player">
          <ResponsiveEmbed src={url} allowFullScreen />
        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/routes/videos/Video.js